import Vue from 'vue';

const header =
{
    namespaced: true,
    state: {
        chapters: [
            {
                name:"Организации",
                route: "/enterprises"
            },
            {
                name:"Пользователи",
                route: "/users"
            },
            {
                name:"Справочники",
                route: "/referenses"
            },
            {
                name:"Безопасность",
                route: "/security"
            },
            {
                name:"Шаблоны",
                route: "/templates"
            }
        ]
    },
    getters: {        
        getMyChapters: (state,  getters, rootStates, rootGetters) => {

            let userInfo = rootGetters['auth/getUserInfo'];
            console.log('userInfo', userInfo);
            let items = state.chapters.reduce( function (items, chapter) {
                
                // исключаем модуль Шаблоны для AvroraAdmin
                if (chapter.route == "/templates" && userInfo.levelAccess == 100)
                    return items;

                items.push({ name: chapter.name, route: chapter.route });
                return items;

            }, []);

            if (Vue.config.devtools) {
                items.push({ name: "Песочница", route: "/sandbox" });
            }

            return items;
        }
    }
}

export default header;